<div class="catalogs-tab d-flex flex-column gap-3 h-100">
  <div class="panel_title">
    {{ 'Aktuell für die Preparation vorgesehener Katalog' | translate }}
  </div>

  <div
    class="upload-zone"
    [class.upload-zone--dragover]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
  >
    <div class="upload-zone__content">
      <dx-sortable
        class="d-flex justify-content-center align-items-center dropZone"
        style="height: 88px; width: 100%;"
        group="catalogDragGroup"
        dropFeedbackMode="indicate"
        [allowDropInsideItem]="true"
        (onAdd)="onDropAddTop($event)"
      >
        <div class="w-100" *ngIf="activeCatalogName">
          <div
            class="catalog-row catalog-row--active"
            (click)="onCatalogRowClick(container?.activeCatalogId)"
            [class.catalog-row--selected]="selectedCatalogId === container?.activeCatalogId"
          >
            <div class="catalog-row__drag">
              <i class="dx-icon-menu"></i>
            </div>
            <div class="catalog-row__main">
              <div class="catalog-row__title">
                {{ activeCatalogName }}
              </div>
              <div class="catalog-row__subtitle">
                {{ 'Aktiver Katalog' | translate }}
              </div>
            </div>
            <div class="catalog-row__actions">
              <dx-button icon="export" stylingMode="text" type="default" (onClick)="onCatalogJumpClicked(container?.activeCatalogId)"></dx-button>
              <dx-button
                icon="overflow"
                stylingMode="text"
                type="default"
                (onClick)="onCatalogOverflowClicked(container?.activeCatalogId, $event)"
              >
              </dx-button>
            </div>
          </div>
        </div>

        <div class="text-center w-100" *ngIf="!activeCatalogName">
          <div style="font-size: 12px; opacity: 0.9; margin-top: 6px;">
            <i class="dx-icon-add" style="font-size: 18px; vertical-align: middle;"></i>
            <span style="margin-left: 6px;">{{ 'Katalog hier ablegen' | translate }}</span>
          </div>
        </div>
      </dx-sortable>

      <input #fileInput type="file" multiple class="d-none" (change)="onFileInputChange($event)" />
    </div>
  </div>

  <div *ngIf="!hasCatalogs" class="empty-state">
    {{ 'Und hier entsteht Ihr Katalogimportarchiv!' | translate }}
  </div>

  <div *ngIf="hasCatalogs" class="d-flex flex-row gap-3 flex-wrap">
    <div class="panel">
      <div class="panel_title">
        {{ 'Vergleichskatalog' | translate }}
      </div>

      <dx-select-box
        [items]="compareCandidates"
        displayExpr="catalogName"
        valueExpr="id"
        [value]="compareCatalogId"
        [searchEnabled]="true"
        [showClearButton]="true"
        placeholder="{{ 'Katalog wählen …' | translate }}"
        (onValueChanged)="onCompareChanged($event)"
      >
      </dx-select-box>

      <div *ngIf="compareCatalog as catalogCompare" class="catalog-card mt-3">
        <div class="catalog-card__header">
          <span class="badge badge--compare">{{ 'Vergleich' | translate }}</span>
          <span class="catalog-card__name">{{ catalogCompare.catalogName }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="panel_archiv">
  <div *ngIf="isArchiveLoading" class="mt-2">
    {{ 'Lade Katalogarchiv …' | translate }}
  </div>

  <div *ngIf="!isArchiveLoading && (!archiveCatalogs || archiveCatalogs.length === 0)" class="mt-2">
    {{ 'Und hier entsteht Ihr Katalogimportarchiv für !' | translate }}
  </div>

  <div *ngIf="!isArchiveLoading && archiveCatalogs?.length" class="mt-2">
    <div class="catalog-list">
      <dx-sortable
        [data]="archiveCatalogs"
        itemOrientation="vertical"
        handle=".catalog-row__drag"
        dragDirection="vertical"
        (onReorder)="onArchiveReorder($event)"
      >
        <div
          class="catalog-row catalog-row--archive"
          *ngFor="let catalog of archiveCatalogs"
          dxSortableItem
          (click)="onCatalogRowClick(catalog.id)"
          [class.catalog-row--selected]="selectedCatalogId === catalog.id"
        >
          <div class="catalog-row__drag">
            <i class="dx-icon-menu"></i>
          </div>
          <div class="catalog-row__main">
            <div class="catalog-row__title">
              {{ catalog.name }}
            </div>
          </div>
          <div class="catalog-row__actions">
            <dx-button
              icon="overflow"
              stylingMode="text"
              type="default"
              (onClick)="onCatalogOverflowClicked(catalog.id, $event)"
            >
            </dx-button>
          </div>
        </div>
      </dx-sortable>
    </div>
  </div>
    
    <dx-context-menu
        #catalogContextMenu
        [dataSource]="contextMenuItems"
        showEvent=""
        [width]="200"
        (onItemClick)="itemClick($event)">
        <div *dxTemplate="let e of 'item'">
            <div>
                <span [ngClass]="e.icon"></span>
                <span *ngIf="e.items" class="dx-icon-spinright"></span> {{ e.text }}
            </div>
        </div>
    </dx-context-menu>

    <dx-popup
        class="popup"
        [width]="500"
        [height]="300"
        [showTitle]="true"
        title="Mime importieren"
        [dragEnabled]="true"
        [hideOnOutsideClick]="true"
        [showCloseButton]="true"
        [(visible)]="importMimeVisible"
        (onHiding)="hideImportMime()"
        contentTemplate="popupContent"
    >
        <div *dxTemplate="let data of 'popupContent'">
            <importMime [(isTemplate)]="isTemplate"></importMime>
        </div>
    </dx-popup>
    
    
</div>
